import Vue from 'vue';
import CostlistService from '@/app/costlist/costlist.service';

const getDefaultAll = () => ({
    name: null,
    zeitaufwandAntrieb: 0,
    zeitaufwandProfilbearbeitung: 0,
    zeitaufwandVerglasen: 0,
    proFluegel: false,
    bemerkung: null,
});

const getDefaultKommissionierung = () => ({
    name: null,
    zeitaufwandProfilbearbeitung: 0,
    zeitaufwandVerglasen: 0,
    zeitaufwandVersand: 0,
    proFluegel: false,
    bemerkung: null,
});

const getDefaultAntriebstyp = () => ({
    name: null,
    zeitaufwandAntrieb: 0,
    zeitaufwandVerglasen: 0,
    proFluegel: false,
    bemerkung: null,
    platzierung: 1,
});

const getDefaultProfilbearbeitung = () => ({
    name: null,
    zeitaufwandProfilbearbeitung: 0,
    zeitaufwandVerglasen: 0,
    proFluegel: false,
    bemerkung: null,
});
const getDefaultOnlyProfilbearbeitung = () => ({
    name: null,
    zeitaufwandProfilbearbeitung: 0,
    proFluegel: false,
    bemerkung: null,
});

const getDefaultVerglasen = () => ({
    name: null,
    zeitaufwandVerglasen: 0,
    proFluegel: false,
    bemerkung: null,
});

const getDefaultAbwesenheit = () => ({
    start: null,
    ende: null,
});

const getDefaultMitarbeiter = () => ({
    name: null,
    arbeitszeit: {
        montag: 0,
        dienstag: 0,
        mittwoch: 0,
        donnerstag: 0,
        freitag: 0,
    },
    abwesenheiten: [],
    bemerkung: null,
});

const getDefaultBetriebsurlaub = () => ({
    start: null,
    ende: null,
    bemerkung: null,
});

const getDefaultFeiertag = () => ({
    date: null,
    name: null,
});

const getDefaultMaw = () => ({
    intMaw: 120,
    extMaw: 150,
    travelFlatRate: 100,
    versandCost: 100,
});

const getDefaultEmployeeTime = () => ({
    mitarbeiter: [],
});

const getDefaultCapacities = () => ({
    antriebstyp: [],
    sonderfunktion: [],
    verriegelung: [],
    beschlagProfilbearbeitung: [],
    beschlagVerglasen: [],
    beschlagVerpackung: 0,
    standardglaeser: [],
    sonderglaeser: [],
    bodenfuehrungZeitaufwand: 0,
    schutzfluegel: [],
    freitraeger: [],
    seitenteil: [],
    kommissionierung: 0,
});

const getDefaultPriceListAntriebstypen = () =>
    [
        'SL NT',
        'SL NT-FR',
        'ECdrive T2 eco',
        'ECdrive T2 100mm',
        'ECdrive T2-FR 100mm',
        'PL NT Haube 150mm',
        'PL NT-FR Haube 150mm',
        'PL NT Haube 200mm',
        'PL NT-FR Haube 200mm',
        'SLT',
        'SLT-FR',
        'SL RC2',
        'SL-FR RC2',
        'SL BO',
        'SL-T30',
        'PL-T30 Haube 150mm',
        'PL-T30 Haube 200mm',
        'PL-HT',
        'MCRdrive',
        'Sonstige',
    ].map((name, index) => ({
        name,
        preis: 0,
        partner: 0,
        zeit: 0,
        platzierung: index + 1,
    }));

const getDefaultPriceListDrehtuerAntriebstypen = () => [];

const getDefaultPriceListVerriegelung = () =>
    [
        'Elek. Verriegelung',
        'Elek Stangenverriegelung',
        'Riegelkontakt einfach',
        'Riegelkontakt 2 fach',
        'Hackenriegelschloß Lock A',
        'Lock M einseitig sperrbar',
        'Lock M beidseitig sperrbar',
    ].map((name) => ({
        name,
        preis: 0,
        zeit: 0,
        ausnahme: [],
        hinweis: null,
    }));

const getDefaultPriceListBrandschutz = () =>
    [
        'Rauschalterzentrale RSZ 7',
        'Rauchmelder GC 152 GEZE ID 139850',
        'Wandwinkel für Rauchmelder GEZE ID 150264',
        'Wireless KIT GC 170 GEZE ID 163692',
        'Unterbrechertaster AS 500 GEZE ID 116266',
        'AP Dose 1-fach GEZE ID 120503',
    ].map((name) => ({
        name,
        preis: 0,
    }));

const getDefaultPriceTimeItem = (name = null) => ({
    name,
    preis: 0,
    zeit: 0,
});

const getDefaultTimeItem = () => ({
    zeit: 0,
});

const getDefaultPriceListVarianteAbmessungen = () => ({
    fluegel: ['1-flügelig', '2-flügelig', '4-flügelig'].map((name) => getDefaultPriceTimeItem(name)),
    oberlichtDurchGeze: ['1-teilig', '2-teilig', '3-teilig'].map((name) => getDefaultPriceTimeItem(name)),
});

const getDefaultPriceListFluegelart = () => ({
    esgGlasbeschlag: getDefaultTimeItem(),
    gcProfileTherm: getDefaultTimeItem(),
    igg: getDefaultTimeItem(),
    ggs: getDefaultTimeItem(),
    fsg: getDefaultTimeItem(),
    fluegelBauseitsFertigungOhneGlasbearbeitung: getDefaultTimeItem(),
    nassverglasen: getDefaultTimeItem(),
});

const getDefaultPriceListBodenfuehrung = () => ({
    durchgehendeBodenfuehrung: {
        preis: 0,
        zeit: 0,
    },
});

const getDefaultPriceListBodenschloss = () => ({
    bodenschloss: {
        preis: 0,
        zeit: 0,
    },
    profilhalbzylinderBeidseitig71mmGezeId23356: getDefaultTimeItem(),
});

const getDefaultPriceListAnfahrtspauschalen = () => [
    {
        kosten: 140,
        postleitzahlen: [
            '10xx',
            '11xx',
            '12xx',
            '13xx',
            '2000-2042',
            '21xx',
            '22xx',
            '23xx',
            '24xx',
            '25xx',
            '2601-2604',
            '27xx',
            '30xx',
            '31xx',
            '32xx',
            '3300-3333',
            '3350-3393',
            '34xx',
            '35xx',
            '36xx',
            '3701-3730',
            '40xx',
            '41xx',
            '42xx',
            '43xx',
            '44xx',
            '4501-4563',
            '4592-4595',
            '46xx',
            '4701-4741',
            '4820-4823',
            '4845-4894',
            '50xx',
            '51xx',
            '52xx',
            '53xx',
            '54xx',
            '60xx',
            '61xx',
            '6200-6277',
            '6300-6324',
            '6401-6441',
            '67xx',
            '68xx',
            '69xx',
            '70xx',
            '71xx',
            '72xx',
            '73xx',
            '7434-7453',
            '80xx',
            '81xx',
            '8200-8225',
            '8261-8295',
            '8301-8362',
            '84xx',
            '85xx',
            '90xx',
            '91xx',
            '92xx',
            '93xx',
            '94xx',
            '95xx',
        ],
    },
    {
        kosten: 280,
        postleitzahlen: [
            '2051-2095',
            '2620-2680',
            '28xx',
            '3334-3345',
            '3741-3763',
            '38xx',
            '39xx',
            '4564-4591',
            '4742-4794',
            '4800-4817',
            '4824-4844',
            '49xx',
            '55xx',
            '56xx',
            '57xx',
            '6280-6295',
            '6330-6395',
            '6444-6493',
            '65xx',
            '66xx',
            '7400-7433',
            '7461-7474',
            '75xx',
            '8230-8255',
            '8380-8385',
            '86xx',
            '87xx',
            '88xx',
            '89xx',
            '96xx',
            '97xx',
            '98xx',
            '99xx',
        ],
    },
];

export function ensurePriceFields(priceList) {
    // Migrate the former named rows without losing configured side prices.
    if (Array.isArray(priceList.ansteuerung)) {
        const previous = priceList.ansteuerung;
        const sides = {};
        [
            ['antriebsseite', 'Antriebsseite'],
            ['antriebsgegenseite', 'Antriebsgegenseite'],
        ].forEach(([key, name]) => {
            const item = previous.find((entry) => entry.name === name);
            sides[key] = item ? { partner: item.partner ?? 0, zeit: item.zeit ?? 0, preis: item.preis ?? 0 } : { partner: 0, zeit: 0, preis: 0 };
        });
        Vue.set(priceList, 'ansteuerung', sides);
    }
    if (!priceList.ansteuerung) Vue.set(priceList, 'ansteuerung', {});
    ['antriebsseite', 'antriebsgegenseite'].forEach((key) => {
        if (!priceList.ansteuerung[key]) Vue.set(priceList.ansteuerung, key, { partner: 0, zeit: 0, preis: 0 });
    });
    const wings = priceList.sicherungsSchutzfluegel || {};
    const keys = ['antriebsseiteLinks', 'antriebsseiteRechts', 'schutzfluegel'];
    if (!priceList.sicherungsSchutzfluegel || Object.keys(wings).some((key) => !keys.includes(key))) {
        Vue.set(priceList, 'sicherungsSchutzfluegel', Object.fromEntries(keys.map((key) => [key, wings[key] || { partner: 0, zeit: 0, preis: 0 }])));
    }
    keys.forEach((key) => {
        if (!priceList.sicherungsSchutzfluegel[key]) Vue.set(priceList.sicherungsSchutzfluegel, key, { partner: 0, zeit: 0, preis: 0 });
    });
    if (priceList.antriebstyp && priceList.antriebstyp.endlagenueberwachungKosten?.preis == null) {
        Vue.set(priceList.antriebstyp, 'endlagenueberwachungKosten', {
            partner: 0,
            zeit: 0,
            preis: Number(priceList.antriebstyp.endlagenueberwachung) || 0,
        });
    }
    const visit = (value) => {
        if (!value || typeof value !== 'object') return;
        if (['preis', 'zeit', 'partner'].some((field) => Object.prototype.hasOwnProperty.call(value, field))) {
            ['partner', 'zeit', 'preis'].forEach((field) => {
                if (value[field] == null) Vue.set(value, field, 0);
            });
        } else {
            Object.keys(value).forEach((key) => visit(value[key]));
        }
    };
    Object.keys(priceList)
        .filter((key) => key !== 'anfahrtspauschale')
        .forEach((key) => visit(priceList[key]));
    return priceList;
}

const getDefaultPriceList = () =>
    ensurePriceFields({
        ansteuerung: {
            antriebsseite: { partner: 0, zeit: 0, preis: 0 },
            antriebsgegenseite: { partner: 0, zeit: 0, preis: 0 },
        },
        sicherungsSchutzfluegel: {
            antriebsseiteLinks: { partner: 0, zeit: 0, preis: 0 },
            antriebsseiteRechts: { partner: 0, zeit: 0, preis: 0 },
            schutzfluegel: { partner: 0, zeit: 0, preis: 0 },
        },
        stundensatz: 0,
        anfahrtspauschale: {
            anfahrtspauschalen: getDefaultPriceListAnfahrtspauschalen(),
            defaultKosten: 0,
        },
        antriebstyp: {
            antriebstypen: getDefaultPriceListAntriebstypen(),
            endlagenueberwachung: 0,
            revisionsklappeEinteilig: {
                preis: 0,
                zeit: 0,
            },
            revisionsklappeZweiteilig: {
                preis: 0,
                zeit: 0,
            },
            revisionsklappeDreiteilig: {
                preis: 0,
                zeit: 0,
            },
            verriegelung: getDefaultPriceListVerriegelung(),
        },
        drehtuerAntriebstyp: {
            antriebstypen: getDefaultPriceListDrehtuerAntriebstypen(),
        },
        brandschutz: getDefaultPriceListBrandschutz(),
        varianteAbmessungen: getDefaultPriceListVarianteAbmessungen(),
        fluegelart: getDefaultPriceListFluegelart(),
        bodenfuehrung: getDefaultPriceListBodenfuehrung(),
        bodenschloss: getDefaultPriceListBodenschloss(),
    });

const ensureNamedCollection = (target, key, defaults) => {
    if (!target[key] || !Array.isArray(target[key])) {
        Vue.set(target, key, JSON.parse(JSON.stringify(defaults)));
        return;
    }
    defaults.forEach((defaultItem) => {
        const existingItem = target[key].find((item) => item.name === defaultItem.name);
        if (!existingItem) {
            target[key].push(JSON.parse(JSON.stringify(defaultItem)));
            return;
        }
        Object.keys(defaultItem).forEach((field) => {
            if (existingItem[field] === undefined) {
                Vue.set(existingItem, field, defaultItem[field]);
            }
        });
    });
};

const getDefaultItem = () => ({
    _id: null,
    maw: getDefaultMaw(),
    capacities: getDefaultCapacities(),
    employeeTime: getDefaultEmployeeTime(),
    priceList: getDefaultPriceList(),
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    defaultAntriebstyp: getDefaultAntriebstyp(),
    defaultAll: getDefaultAll(),
    defaultKommissionierung: getDefaultKommissionierung(),
    defaultProfilbearbeitung: getDefaultProfilbearbeitung(),
    defaultOnlyProfilbearbeitung: getDefaultOnlyProfilbearbeitung(),
    defaultVerglasen: getDefaultVerglasen(),
    defaultAbwesenheit: getDefaultAbwesenheit(),
    defaultMitarbeiter: getDefaultMitarbeiter(),
    defaultBetriebsurlaub: getDefaultBetriebsurlaub(),
    defaultFeiertag: getDefaultFeiertag(),
});

const costlist = {
    namespaced: true,
    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        clear(state) {
            Vue.set(state, 'item', JSON.parse(JSON.stringify(getDefaultState().item)));
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await CostlistService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await CostlistService.update(client_data._id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context) {
            const { data } = await CostlistService.findFirst();
            if (data.employeeTime === null || data.employeeTime === undefined) {
                data.employeeTime = { mitarbeiter: [] };
            }
            if (data.capacities === null || data.capacities === undefined) {
                data.capacities = getDefaultCapacities();
            }
            if (data.maw === null || data.maw === undefined) {
                data.maw = getDefaultMaw();
            }
            if (data.priceList === null || data.priceList === undefined) {
                data.priceList = getDefaultPriceList();
            } else {
                const defaultPriceList = getDefaultPriceList();
                if (data.priceList.stundensatz === undefined || data.priceList.stundensatz === null) {
                    Vue.set(data.priceList, 'stundensatz', defaultPriceList.stundensatz);
                }
                if (data.priceList.antriebstyp === null || data.priceList.antriebstyp === undefined) {
                    data.priceList.antriebstyp = defaultPriceList.antriebstyp;
                } else if (Array.isArray(data.priceList.antriebstyp.antriebstypen) && data.priceList.antriebstyp.antriebstypen.length === 0) {
                    data.priceList.antriebstyp.antriebstypen = getDefaultPriceListAntriebstypen();
                }
                if (data.priceList.drehtuerAntriebstyp === null || data.priceList.drehtuerAntriebstyp === undefined) {
                    Vue.set(data.priceList, 'drehtuerAntriebstyp', defaultPriceList.drehtuerAntriebstyp);
                } else if (!Array.isArray(data.priceList.drehtuerAntriebstyp.antriebstypen)) {
                    Vue.set(data.priceList.drehtuerAntriebstyp, 'antriebstypen', getDefaultPriceListDrehtuerAntriebstypen());
                }
                [data.priceList.antriebstyp.antriebstypen, data.priceList.drehtuerAntriebstyp.antriebstypen].forEach((antriebstypen) => {
                    if (Array.isArray(antriebstypen)) {
                        antriebstypen.forEach((antriebstyp) => {
                            if (antriebstyp.partner === undefined || antriebstyp.partner === null) {
                                Vue.set(antriebstyp, 'partner', 0);
                            }
                        });
                    }
                });
                if (Array.isArray(data.priceList.antriebstyp.antriebstypen)) {
                    const antriebstypen = data.priceList.antriebstyp.antriebstypen;
                    const placements = antriebstypen.map((antriebstyp) => Number(antriebstyp.platzierung));
                    const hasUniqueValidPlacements =
                        placements.every((placement) => Number.isInteger(placement) && placement > 0) && new Set(placements).size === placements.length;

                    if (hasUniqueValidPlacements) {
                        antriebstypen.sort((left, right) => left.platzierung - right.platzierung);
                    }
                    antriebstypen.forEach((antriebstyp, index) => Vue.set(antriebstyp, 'platzierung', index + 1));
                }
                if (Array.isArray(data.priceList.drehtuerAntriebstyp.antriebstypen)) {
                    const antriebstypen = data.priceList.drehtuerAntriebstyp.antriebstypen;
                    const placements = antriebstypen.map((antriebstyp) => Number(antriebstyp.platzierung));
                    const hasUniqueValidPlacements =
                        placements.every((placement) => Number.isInteger(placement) && placement > 0) && new Set(placements).size === placements.length;

                    if (hasUniqueValidPlacements) {
                        antriebstypen.sort((left, right) => left.platzierung - right.platzierung);
                    }
                    antriebstypen.forEach((antriebstyp, index) => Vue.set(antriebstyp, 'platzierung', index + 1));
                }
                if (Array.isArray(data.capacities.antriebstyp)) {
                    const antriebstypen = data.capacities.antriebstyp;
                    const placements = antriebstypen.map((antriebstyp) => Number(antriebstyp.platzierung));
                    const hasUniqueValidPlacements =
                        placements.every((placement) => Number.isInteger(placement) && placement > 0) && new Set(placements).size === placements.length;

                    if (hasUniqueValidPlacements) {
                        antriebstypen.sort((left, right) => left.platzierung - right.platzierung);
                    }
                    antriebstypen.forEach((antriebstyp, index) => Vue.set(antriebstyp, 'platzierung', index + 1));
                }
                if (data.priceList.anfahrtspauschale === null || data.priceList.anfahrtspauschale === undefined) {
                    data.priceList.anfahrtspauschale = defaultPriceList.anfahrtspauschale;
                } else if (
                    !Array.isArray(data.priceList.anfahrtspauschale.anfahrtspauschalen) ||
                    data.priceList.anfahrtspauschale.anfahrtspauschalen.length === 0
                ) {
                    data.priceList.anfahrtspauschale.anfahrtspauschalen = getDefaultPriceListAnfahrtspauschalen();
                }
                if (Array.isArray(data.priceList.antriebstyp.verriegelung) && data.priceList.antriebstyp.verriegelung.length === 0) {
                    data.priceList.antriebstyp.verriegelung = getDefaultPriceListVerriegelung();
                }
                if (Array.isArray(data.priceList.antriebstyp.verriegelung)) {
                    data.priceList.antriebstyp.verriegelung.forEach((verriegelung) => {
                        if (!Array.isArray(verriegelung.ausnahme)) {
                            Vue.set(verriegelung, 'ausnahme', []);
                        }
                    });
                }
                if (!Array.isArray(data.priceList.brandschutz) || data.priceList.brandschutz.length === 0) {
                    data.priceList.brandschutz = getDefaultPriceListBrandschutz();
                }
                if (!data.priceList.varianteAbmessungen) {
                    Vue.set(data.priceList, 'varianteAbmessungen', defaultPriceList.varianteAbmessungen);
                }
                ensureNamedCollection(data.priceList.varianteAbmessungen, 'fluegel', defaultPriceList.varianteAbmessungen.fluegel);
                ensureNamedCollection(data.priceList.varianteAbmessungen, 'oberlichtDurchGeze', defaultPriceList.varianteAbmessungen.oberlichtDurchGeze);
                if (!data.priceList.fluegelart) {
                    Vue.set(data.priceList, 'fluegelart', defaultPriceList.fluegelart);
                }
                Object.keys(defaultPriceList.fluegelart).forEach((key) => {
                    if (!data.priceList.fluegelart[key]) {
                        Vue.set(data.priceList.fluegelart, key, defaultPriceList.fluegelart[key]);
                    }
                });
                if (!data.priceList.bodenfuehrung) {
                    Vue.set(data.priceList, 'bodenfuehrung', defaultPriceList.bodenfuehrung);
                }
                if (!data.priceList.bodenfuehrung.durchgehendeBodenfuehrung) {
                    Vue.set(data.priceList.bodenfuehrung, 'durchgehendeBodenfuehrung', defaultPriceList.bodenfuehrung.durchgehendeBodenfuehrung);
                }
                if (!data.priceList.bodenschloss) {
                    Vue.set(data.priceList, 'bodenschloss', defaultPriceList.bodenschloss);
                }
                Object.keys(defaultPriceList.bodenschloss).forEach((key) => {
                    if (!data.priceList.bodenschloss[key]) {
                        Vue.set(data.priceList.bodenschloss, key, defaultPriceList.bodenschloss[key]);
                    }
                });
            }
            ensurePriceFields(data.priceList);
            context.commit('update', data);
            return data;
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        defaultAll(state) {
            return state.defaultAll;
        },
        defaultKommissionierung(state) {
            return state.defaultKommissionierung;
        },
        defaultAntriebstyp(state) {
            return state.defaultAntriebstyp;
        },
        defaultProfilbearbeitung(state) {
            return state.defaultProfilbearbeitung;
        },
        defaultOnlyProfilbearbeitung(state) {
            return state.defaultOnlyProfilbearbeitung;
        },
        defaultVerglasen(state) {
            return state.defaultVerglasen;
        },
        defaultFeiertag(state) {
            return state.defaultFeiertag;
        },
        defaultBetriebsurlaub(state) {
            return state.defaultBetriebsurlaub;
        },
        defaultMitarbeiter(state) {
            return state.defaultMitarbeiter;
        },
        defaultAbwesenheit(state) {
            return state.defaultAbwesenheit;
        },
    },
};
export { getDefaultItem };
export default costlist;
